import { atom, getDefaultStore } from "jotai";
import { ImportXLFileCommand, MCDataQuestion, MCTestDataDto } from "../DomainModels";
import { produce } from "immer";
import { OpticFor_ } from "optics-ts";
import { focusAtom } from "jotai-optics";
import languageService from "src/utils/languageService";
import api from "src/services/api/axiosService";

const endPoints = {
    POST_IMPORT_XL: (partId: string, testId: string) => `author/coursepart/${partId}/test/${testId}/ImportSpreadsheet`,

}

export type McEditData = {
    testData: MCTestDataDto;
    currentQuestionIndex?: number
}
const store = getDefaultStore();

export class MCTestService {

    public datatom;
    public currentQuestionAtom;
    public currentQuestionInitialAtom;
    private questionIndex: number = -1;

    constructor(data: MCTestDataDto) {

        data.Questions.forEach((q, i) => q.Index = i);
        this.datatom = atom<MCTestDataDto>(data);
        this.datatom.debugLabel = "McTestdatatom";
        this.currentQuestionAtom = (index: number) => {
            const atom = focusAtom(
                this.datatom,
                (optic: OpticFor_<MCTestDataDto>) => optic.prop("Questions").at(index));
            atom.debugLabel = "question: " + index;
            return atom;
        };
        this.currentQuestionInitialAtom = atom<MCDataQuestion | undefined>(undefined);
    }

    private MutateMCState(method: (state: MCTestDataDto) => void) {
        const state = store.get(this.datatom);
        const newstate = produce(state, (draft) => {
            method(draft);
        })
        store.set(this.datatom, newstate);
        return newstate;
    }

    public setPercentage(value: number) {
        return this.MutateMCState(draft => {
            draft.Percentage = value;
        });

    }

    public handleChange = (data: MCDataQuestion) => {
        return this.MutateMCState(draft => {
            draft.Questions.splice(data.Index, 1, data);
        });
    };

    public setCurrentQuestion(index: number) {
        const data = store.get(this.datatom);
        if (index < 0 || index >= data.Questions.length) {
            throw new Error("index out of bound")
        }

        this.questionIndex = index;

        const currentQuestion = this.MutateMCState(draft => {
            draft.Questions.forEach((q, i) => q.Checked = i === index);
        });

        return currentQuestion.Questions[index];
    }
    updateQuestionText(value: string) {
        return this.MutateMCState(state => {

            if (!state.Questions[this.questionIndex]) return;

            state.Questions[this.questionIndex].Question = value;
            state.Questions[this.questionIndex].QuestionError
                = value === "" ? languageService.getText("required_field") : undefined;
        });

    }

    addAnswer() {
        return this.MutateMCState(state => {
            const question = state.Questions[this.questionIndex];
            if (!question) return;

            question.McAnswers.push({ Text: "", IsCorrect: false });
        });
    }

    removeAnswer(index: number) {
        return this.MutateMCState(state => {

            const question = state.Questions[this.questionIndex];
            if (!question?.McAnswers[index]) return;

            if (question.McAnswers.length > 2) {
                question.McAnswers.splice(index, 1);
                if (question.McAnswers.filter(a => a.IsCorrect).length === 0 ) {
                    question.McAnswers[0].IsCorrect = true;
                }
            }
        });
    }

    updateAnswerText(value: string, index: number) {
        return this.MutateMCState(state => {
            if (!state.Questions[this.questionIndex]?.McAnswers[index]) return;

            state.Questions[this.questionIndex].McAnswers[index].Text = value;
            state.Questions[this.questionIndex].McAnswers[index].Error
                = value === "" ? languageService.getText("required_field") : undefined;
        });
    }

    updateAnswerIsCorrect(checked: boolean, answerIndex: number) {

        return this.MutateMCState(state => {
            if (!state.Questions[this.questionIndex]?.McAnswers[answerIndex]) return;

            state.Questions[this.questionIndex].McAnswers[answerIndex].IsCorrect = checked;
        });
    }

    setCanSelectMultipleAnswers(value: boolean) {

        return this.MutateMCState(state => {
            if (!state.Questions[this.questionIndex]) return;

            state.Questions[this.questionIndex].CanSelectMultipleAnswers = value;
            if (value === false) {
                state.Questions[this.questionIndex].McAnswers.forEach((a, i) => a.IsCorrect = i === 0)
            }
        });

    }

    public addQuestion() {

        return this.MutateMCState(state => {
            const q: MCDataQuestion = {
                Question: languageService.getText("click.to.edit"),
                CanSelectMultipleAnswers: false,
                Index: state.Questions.length,
                McAnswers: [{ Text: "", IsCorrect: true }, { Text: "", IsCorrect: false }]
            }
            state.Questions.push(q);
        });
    }

    public deleteQuestion(questionIndex: number) {
        return this.MutateMCState(state => {
            if (this.questionIndex === questionIndex) {
                this.questionIndex = -1
            }
            state.Questions.splice(questionIndex, 1);
            state.Questions.forEach((q, i) => q.Index = i);

        });
    }

    public async importFromXL(data: ImportXLFileCommand) {
        const newDataResponse = await api.post<MCTestDataDto>(endPoints.POST_IMPORT_XL(data.PartId, data.TestId), data);
        if (newDataResponse.status === 200) {
            this.MutateMCState(draft => {
                draft.Questions = newDataResponse.data.Questions;
                draft.Questions.forEach((q, i) => q.Index = i);
            });
        }
    }



}
